import MxTypography from "@rf-l1/MxTypography";

interface MxDetailCardAgentNameProps {
  name: string;
}
const MxDetailCardAgentName = (props: MxDetailCardAgentNameProps) => {
  return (
    <MxTypography
      color="primary.main"
      variant="body2"
      fontWeight={600}
      autoCopy
      removeAutoCopyStyles
    >
      {props.name}
    </MxTypography>
  );
};
export default MxDetailCardAgentName;
